import { render, staticRenderFns } from "./confirmMobile.vue?vue&type=template&id=2dabc47a&scoped=true&"
import script from "./confirmMobile.vue?vue&type=script&lang=js&"
export * from "./confirmMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dabc47a",
  null
  
)

export default component.exports